import { render, staticRenderFns } from "./CompanyAdminPanel.vue?vue&type=template&id=3515e44b&scoped=true"
import script from "./CompanyAdminPanel.vue?vue&type=script&lang=js"
export * from "./CompanyAdminPanel.vue?vue&type=script&lang=js"
import style0 from "./CompanyAdminPanel.vue?vue&type=style&index=0&id=3515e44b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3515e44b",
  null
  
)

export default component.exports